import { Link } from 'react-router-dom';
import { Box } from '@mui/material';

export const ResetPasswordSuccessPage: React.FC = () => {
  return (
    <Box className="row text-center">
      <h3 className="col-md-12">Password successfully reset</h3>
      <Link to="/" className="col-md-12">
        Continue to home page
      </Link>
    </Box>
  );
};
